module.exports = __webpack_public_path__ + "img/mob3.28d88421.png";